import * as React from 'react';

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import MobileStepper from '@mui/material/MobileStepper';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

const steps = [
  "Branch & Event Date",
  "Themes",
  "Time-slots",
  "Add-ons",
  "Customer Details",
  "Review"
];

export default function ResponsiveStepper({ children, onNext,
  onBack, activeStep }) {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));
  const maxSteps = steps.length;
  return (
    <>
      <Box sx={{ width: '100%' }}>
        {isMobileOrTablet ? (
          <>
            <Box
              sx={{
                px: 2,
                pt: 2,
                pb: 10,
              }}
            >
              {children}
            </Box>

            {activeStep < 6 && <Box
              sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                bgcolor: '#fff',
                borderTop: '1px solid #e5e7eb',
                zIndex: 50,
              }}
            >
              <MobileStepper
                variant="dots"
                steps={maxSteps}
                position="static"
                activeStep={activeStep}
                nextButton={
                  <Button
                    size="small"
                    onClick={onNext}
                  >
                    {activeStep === maxSteps - 1 ? 'Create' : 'Next'}
                    {theme.direction === 'rtl'
                      ? <KeyboardArrowLeft />
                      : <KeyboardArrowRight />}
                  </Button>
                }
                backButton={
                  <Button
                    size="small"
                    onClick={onBack}
                    disabled={activeStep === 0}
                  >
                    {theme.direction === 'rtl'
                      ? <KeyboardArrowRight />
                      : <KeyboardArrowLeft />}
                    Back
                  </Button>
                }
              />

            </Box>
            }
          </>

        ) : (
          <>
            {/* Desktop Stepper */}
            <Stepper activeStep={activeStep} alternativeLabel sx={{
              "& .MuiStepIcon-root.Mui-active": {
                color: "#72398E"
              },
              "& .MuiStepIcon-root.Mui-completed": {
                color: "#72398E"
              }
            }}>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>

            <Box
              sx={{
                maxWidth: 900,
                mx: "auto",
                mt: 4,
                px: 2
              }}
            >
              {children}
            </Box>


            {/* Desktop Navigation Buttons */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                mt: 3,
              }}
            >
              {activeStep < 6 && <>
                <Button
                  variant="outlined"
                  disabled={activeStep === 0}
                  onClick={onBack}
                >
                  Back
                </Button>

                <Button
                  variant="contained"
                  onClick={onNext}
                >
                  {activeStep === maxSteps - 1 ? 'Create' : 'Next'}
                </Button>
              </>}
            </Box>
          </>
        )}
      </Box>
    </>
  );
}
